export default "/static/dashboard/build/app/img/v2/de589816bcd0c0c81e224d323927d9c8.png";